import { requestAppDownload } from "shared/services/appDownload";

export const footerItems = [
  {
    label: "Baixar App para iOS",
    action: (setIsMenuOpen?: (state: boolean) => void) => {
      if (setIsMenuOpen) setIsMenuOpen(false);
      requestAppDownload("ios");
    },
  },
  {
    label: "Baixar App para Android",
    action: (setIsMenuOpen?: (state: boolean) => void) => {
      if (setIsMenuOpen) setIsMenuOpen(false);
      requestAppDownload("android");
    },
  },
  // {
  //   label: "Sobre o Voopter",
  //   action: (setIsMenuOpen?: (state: boolean) => void) => {
  //     if (setIsMenuOpen) setIsMenuOpen(false);
  //     window.open("https://voopter.com/about", "_blank");
  //   },
  // },
  {
    label: "Termos de Uso",
    action: (setIsMenuOpen?: (state: boolean) => void) => {
      if (setIsMenuOpen) setIsMenuOpen(false);
      window.open("https://achados.voopter.com.br/termos", "_blank");
    },
  },
  {
    label: "Política de Privacidade",
    action: (setIsMenuOpen?: (state: boolean) => void) => {
      if (setIsMenuOpen) setIsMenuOpen(false);
      window.open("https://achados.voopter.com.br/privacidade", "_blank");
    },
  },
  // {
  //   label: "Voopter na mídia",
  //   action: (setIsMenuOpen?: (state: boolean) => void) => {
  //     if (setIsMenuOpen) setIsMenuOpen(false);
  //     window.open("https://voopter.com/imprensa", "_blank");
  //   },
  // },
  {
    label: "Fale conosco",
    action: (setIsMenuOpen?: (state: boolean) => void) => {
      if (setIsMenuOpen) setIsMenuOpen(false);
      window.open("https://achados.voopter.com.br/fale-conosco", "_blank");
    },
  },
];
